// src/pages/B2B/crm/components/AgendaList.tsx
import React from 'react';
import { Meeting, VenueListRow } from '../api/types';

type Props = {
  meetings: Meeting[];
  venues: VenueListRow[];
  onEventClick: (m: Meeting) => void;
};

function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' });
}

function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function AgendaList({ meetings, venues, onEventClick }: Props): React.ReactElement {
  const venueName = new Map(venues.map(v => [v.id, v.name]));

  if (meetings.length === 0) {
    return <div className="text-gray-500 text-sm py-8 text-center">No meetings in this window.</div>;
  }

  // Sort by starts_at ascending.
  const sorted = [...meetings].sort((a, b) => a.starts_at.localeCompare(b.starts_at));

  return (
    <div className="space-y-1">
      {sorted.map(m => (
        <button
          key={m.id}
          type="button"
          onClick={() => onEventClick(m)}
          className="w-full text-left bg-[#1a1a2e] hover:bg-[#22223a] border border-[#2a2a3e] rounded-md px-3 py-2 flex items-center gap-3"
        >
          <div className="w-32 text-gray-300 text-sm">
            {fmtDate(m.starts_at)}{!m.all_day && ` · ${fmtTime(m.starts_at)}`}
          </div>
          <div className="flex-1 text-white text-sm truncate">{m.title}</div>
          <div className="text-gray-500 text-xs truncate max-w-[200px]">
            {venueName.get(m.venue_id) ?? '(unknown venue)'}
          </div>
        </button>
      ))}
    </div>
  );
}
